import AppContext from "PFApp/app_context";
import { LandingLayoutWithoutSidebar } from "PFApp/components/landing_layout";
import { useOnboarding } from "PFApp/onboarding/use_onboarding";
import { Button } from "PFComponents/button";
import IconCongrats from "PFIcons/illie_congrats.svg";
import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import OnboardingBox from "../parts/onboarding_box";
import css from "./common.less";
import successCss from "./success_step.less";

const SuccessStep = () => {
  const history = useHistory();
  const { t } = useTranslation("onboarding");
  const { currentProfile } = useContext(AppContext).store;
  const { saveProfile } = useOnboarding("success");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.setTimeout(() => {
      complete();
    }, 5000);
  }, []);

  const complete = () => {
    setLoading(true);
    saveProfile({ registration_status: "active" }).then(() => {
      storage.removeItem("OnboardingInitiated");
      history.push("/");
      history.go(0);
    });
  };

  return (
    <LandingLayoutWithoutSidebar>
      <OnboardingBox qaId="Onboarding.SuccessStep" style={{ textAlign: "center" }}>
        <div className={successCss.icon}>
          <IconCongrats />
        </div>
        <h1>{t("thanksName", { name: (currentProfile || {}).first_name || "" })}</h1>
        <p className={css.tip}>{t("collectedData")}</p>
        <div className={css.center}>
          <Button
            text={t("showMe")}
            onClick={complete}
            qaId="Onboarding.SuccessStep.show_me"
            disabled={loading}
          ></Button>
        </div>
      </OnboardingBox>
    </LandingLayoutWithoutSidebar>
  );
};

export default SuccessStep;
